// Standalone icons (icons/ raíz)
import Calendario from '@icons/calendario.svg';
import CalendarioGris from '@icons/calendario-gris.svg';
import Casa from '@icons/casa.svg';
import Cuota from '@icons/cuota.svg';
import Finanzas from '@icons/finanzas.svg';
import FlashOff from '@icons/flash-off.svg';
import FlashOn from '@icons/flash-on.svg';
import HistorialPagos from '@icons/historial_pagos.svg';
import Qr from '@icons/qr.svg';
import QrV2 from '@icons/qr-2.svg';
import QrLeidos from '@icons/qr_leidos.svg';
import QrRechazado from '@icons/qr_rechazado.svg';
import QrGenerados from '@icons/qr_generados.svg';
import QrActivo from '@icons/qr_activo.svg';
import Rechazar from '@icons/rechazar.svg';
import RechazarWhite from '@icons/rechazar_white.svg';
import Valido from '@icons/valido.svg';
import ValidoWhite from '@icons/valido_white.svg';
import IncidenciaNueva from '@icons/incidencia_nueva.svg';
import IncidenciaProceso from '@icons/incidencia_proceso.svg';
import IncidenciaResuelta from '@icons/incidencia_resuelta.svg';
import Vinte from '@icons/vinte.svg';

// Config (icons/apps/) — tarjetas de la pantalla de Configuración
import ConfigNotificaciones from '@icons/apps/config_notificaciones.svg';
import ConfigMora from '@icons/apps/config_mora.svg';
import ConfigAdmins from '@icons/apps/config_admins.svg';
import ConfigAppV from '@icons/apps/config_appv.svg';

// Tags de acceso por tipo
import TagVehicular from '@icons/tag_vehic.svg';
import TagLlavero from '@icons/tag_key.svg';
import TagActivo from '@icons/tag_activo.svg';
import TagAsignado from '@icons/tag_asignado.svg';
import TagLibre from '@icons/tag_libre.svg';
import TagDesactivado from '@icons/tag_desactivado.svg';

// Actions / UI (icons/actions/)
import Agregar from '@icons/actions/agregar.svg';
import Cerrar from '@icons/actions/cerrar.svg';
import Compartir from '@icons/actions/compartir.svg';
import Eliminar from '@icons/actions/eliminar.svg';
import Foto from '@icons/actions/foto.svg';
import Hora from '@icons/actions/hora.svg';
import RightArrowCircle from '@icons/actions/right-arrow-circle.svg';
import Ubicacion from '@icons/actions/ubicacion.svg';
import AlertCircle from '@icons/actions/alert-circle.svg';
import More from '@icons/actions/more.svg';
import Verified from '@icons/actions/verified.svg';
import ImageIcon from '@icons/actions/image.svg';
import Send from '@icons/actions/send.svg';

// Nav — admin (icons/nav/admin/)
import NavResumen from '@icons/nav/admin/nav_resumen.svg';
import NavResumenActive from '@icons/nav/admin/nav_resumen_active.svg';
import NavResumenWhite from '@icons/nav/admin/nav_resumen_white.svg';
import NavViviendas from '@icons/nav/admin/nav_viviendas.svg';
import NavViviendasActive from '@icons/nav/admin/nav_viviendas_active.svg';
import NavViviendasWhite from '@icons/nav/admin/nav_viviendas_white.svg';
import NavViviendasGreen from '@icons/nav/admin/nav_viviendas_green.svg';
import NavAccesos from '@icons/nav/admin/nav_accesos.svg';
import NavAccesosActive from '@icons/nav/admin/nav_accesos_active.svg';
import NavAccesosWhite from '@icons/nav/admin/nav_accesos_white.svg';
import NavAjustes from '@icons/nav/admin/nav_ajustes.svg';
import NavAjustesActive from '@icons/nav/admin/nav_ajustes_active.svg';
import NavAjustesWhite from '@icons/nav/admin/nav_ajustes_white.svg';
import NavFinanzas from '@icons/nav/admin/nav_finanzas.svg';
import NavFinanzasActive from '@icons/nav/admin/nav_finanzas_active.svg';
import NavFinanzasWhite from '@icons/nav/admin/nav_finanzas_white.svg';
import NavIncidencias from '@icons/nav/admin/nav_incidencias.svg';
import NavIncidenciasActive from '@icons/nav/admin/nav_incidencias_active.svg';
import NavIncidenciasWhite from '@icons/nav/admin/nav_incidencias_white.svg';
import NavComunicados from '@icons/nav/admin/nav_comunicados.svg';
import NavComunicadosWhite from '@icons/nav/admin/nav_comunicados_white.svg';

// Nav — resident (icons/nav/resident/)
import NavResidentAccesos from '@icons/nav/resident/nav_r_accesos.svg';
import NavResidentAccesosActive from '@icons/nav/resident/nav_r_accesos_active.svg';
import NavResidentMivivienda from '@icons/nav/resident/nav_r_mivivienda.svg';
import NavResidentMiviviendaActive from '@icons/nav/resident/nav_r_mivivienda_active.svg';

// Nav — guard (icons/nav/guard/)
import NavGuardAccesos from '@icons/nav/guard/nav_v_accesos.svg';
import NavGuardAccesosActive from '@icons/nav/guard/nav_v_accesos_active.svg';
import NavGuardBitacora from '@icons/nav/guard/nav_v_bitacora.svg';
import NavGuardBitacoraActive from '@icons/nav/guard/nav_v_bitacora_active.svg';
import NavGuardIncidencias from '@icons/nav/guard/nav_v_incidencias.svg';
import NavGuardIncidenciasActive from '@icons/nav/guard/nav_v_incidencias_active.svg';
import NavGuardRegistro from '@icons/nav/guard/nav_v_registro.svg';
import NavGuardRegistroActive from '@icons/nav/guard/nav_v_registro_active.svg';

// Nav — shared (icons/nav/)
import NavPerfil from '@icons/nav/nav_perfil.svg';
import NavPerfilActive from '@icons/nav/nav_perfil_active.svg';
import NavPerfilWhite from '@icons/nav/nav_perfil_white.svg';


export const ICONS = {
  // Standalone
  calendario:       { default: Calendario, gris: CalendarioGris },
  casa:             { default: Casa },
  cuota:            { default: Cuota },
  finanzas:         { default: Finanzas },
  flash:            { default: FlashOff, off: FlashOff, on: FlashOn },
  historialPagos:   { default: HistorialPagos },
  qr:               { default: Qr, v2: QrV2 },
  qrLeidos:         { default: QrLeidos },
  qrRechazado:      { default: QrRechazado },
  qrGenerados:      { default: QrGenerados },
  qrActivo:         { default: QrActivo },
  rechazar:         { default: Rechazar, white: RechazarWhite },
  valido:           { default: Valido, white: ValidoWhite },
  incidenciaNueva:    { default: IncidenciaNueva },
  incidenciaProceso:  { default: IncidenciaProceso },
  incidenciaResuelta: { default: IncidenciaResuelta },
  vinte:            { default: Vinte },

  // Config cards
  configNotificaciones: { default: ConfigNotificaciones },
  configMora:           { default: ConfigMora },
  configAdmins:         { default: ConfigAdmins },
  configAppV:           { default: ConfigAppV },

  // Tags de acceso
  tagVehicular:         { default: TagVehicular },
  tagLlavero:           { default: TagLlavero },
  tagActivo:            { default: TagActivo },
  tagAsignado:          { default: TagAsignado },
  tagLibre:             { default: TagLibre },
  tagDesactivado:       { default: TagDesactivado },

  // Actions / UI
  add:              { default: Agregar },
  close:            { default: Cerrar },
  share:            { default: Compartir },
  delete:           { default: Eliminar },
  picture:          { default: Foto },
  time:             { default: Hora },
  rightArrowCircle: { default: RightArrowCircle },
  location:         { default: Ubicacion },
  alertCircle:      { default: AlertCircle },
  more:             { default: More },
  verified:         { default: Verified },
  image:            { default: ImageIcon },
  send:             { default: Send },

  // Nav admin
  navResumen:      { default: NavResumen,      active: NavResumenActive,      white: NavResumenWhite },
  navViviendas:    { default: NavViviendas,    active: NavViviendasActive,    white: NavViviendasWhite, green: NavViviendasGreen },
  navAccesos:      { default: NavAccesos,      active: NavAccesosActive,      white: NavAccesosWhite },
  navAjustes:      { default: NavAjustes,      active: NavAjustesActive,      white: NavAjustesWhite },
  navFinanzas:     { default: NavFinanzas,     active: NavFinanzasActive,     white: NavFinanzasWhite },
  navIncidencias:  { default: NavIncidencias,  active: NavIncidenciasActive,  white: NavIncidenciasWhite },
  navComunicados:  { default: NavComunicados,  white: NavComunicadosWhite },

  // Nav resident
  navResidentAccesos:    { default: NavResidentAccesos,    active: NavResidentAccesosActive },
  navResidentMivivienda: { default: NavResidentMivivienda, active: NavResidentMiviviendaActive },

  // Nav guard
  navGuardAccesos:     { default: NavGuardAccesos,     active: NavGuardAccesosActive },
  navGuardBitacora:    { default: NavGuardBitacora,    active: NavGuardBitacoraActive },
  navGuardIncidencias: { default: NavGuardIncidencias, active: NavGuardIncidenciasActive },
  navGuardRegistro:    { default: NavGuardRegistro,    active: NavGuardRegistroActive },

  // Nav shared (admin sidebar profile / resident profile / guard profile)
  navPerfil:       { default: NavPerfil,       active: NavPerfilActive,       white: NavPerfilWhite },
};

export type IconName = keyof typeof ICONS;
export type IconVariant<N extends IconName> = keyof (typeof ICONS)[N];
